import { AccordionItem, AccordionTrigger, AccordionContent } from "./Accordion";
import { useEffect } from "react";
import type { AccordionStepProps } from "./AccordionStepProps";
import classes from "./Accordion.module.scss";
import { scrollToTop } from "@/utils/dom";

export const DELAY_BEFORE_SCROLL = 300;

export function AccordionStep(props: AccordionStepProps) {
  const { value, title, children, visible, forceScroll } = props;

  useEffect(() => {
    if (!visible || !forceScroll) {
      return;
    }

    return scrollToTop(DELAY_BEFORE_SCROLL);
  }, [visible, forceScroll]);

  if (!visible) {
    return null;
  }

  return (
    <AccordionItem value={value} className={classes.step}>
      <AccordionTrigger>{title}</AccordionTrigger>
      <AccordionContent>{children}</AccordionContent>
    </AccordionItem>
  );
}
